import { alphas } from '../colors/system/alphas';

export const shadows = {
  base: 'none',
  raised: `0px 2px 12px 0px ${alphas['darken-30']}`,
  subtle: `0px 2px 12px 0px ${alphas['darken-10']}`,
};
